import React from "react";
import { array, bool } from "prop-types";
import { Box, Container } from "@mui/material";
import OndemandVideoRoundedIcon from "@mui/icons-material/OndemandVideoRounded";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import VideoSettingsRoundedIcon from "shared/chrome/menus/icons/VideoSettingsRoundedIcon";
import TipsAndUpdatesRoundedIcon from "shared/chrome/menus/icons/TipsAndUpdatesRoundedIcon";

import { connectToState } from "../../../redux/connect-api";
import ComingSoonCard from "../ComingSoon/ComingSoonCard";
import VideoGrid from "../../VideoGrid";
import DocumentGrid from "../../DocumentGrid";
import CurrentVideo from "../../CurrentVideo";
import RecentUpdates from "../../recent_updates/RecentUpdates";
import ResourceWrapper from "../../ResourceWrapper";
import { sectionStyles } from "shared/theme/styles";
import { comingSoonLoadingSelector, comingSoonSelector } from "../../../selectors";

const COMING_SOON_ITEM_LIMIT = 3;

const AppLandingContent = ({
  mediaResourcesLoading,
  mediaResources = [],
  recentUpdatesLoading,
  recentUpdates = [],
  comingSoonItemsLoading,
  comingSoonItems,
}) => {
  if (!mediaResources.length) return null;

  const resourcesByType = (type) => {
    return mediaResources.filter((r) => r.resource_type === type);
  };

  const resourceVideos = resourcesByType("resource");
  const resourceDocuments = resourcesByType("document");
  const webinars = resourcesByType("webinar");

  const currentWebinar = (webinars.length && webinars[0]) || null;

  let linkToMore = null;
  if (webinars.length > 1) {
    linkToMore = {
      text: "webinars",
      count: webinars.length,
    };
  }
  const currentWebinarElement = currentWebinar ? (
    <ResourceWrapper
      loading={mediaResourcesLoading}
      descriptionPaddingX={2}
      paddingX={0}
      wrapperCount={webinars.length}
      wrapperHref="/webinars"
      WrapperIcon={OndemandVideoRoundedIcon}
      wrapperTitle="Webinars"
    >
      <CurrentVideo video={currentWebinar} linkToMore={linkToMore} style={{ marginTop: "-10px" }} />
    </ResourceWrapper>
  ) : null;
  return (
    <Box component="section" style={sectionStyles}>
      <Container sx={{ px: "0 !important" }}>
        {currentWebinarElement}
        <ResourceWrapper
          loading={mediaResourcesLoading}
          wrapperCount={resourceVideos.length}
          wrapperLimit={3}
          wrapperDescription="Watch our collection of short demo videos to explore the possibilities of ICER Analytics:"
          wrapperHref="/videos"
          WrapperIcon={VideoSettingsRoundedIcon}
          wrapperTitle="Demo Videos"
        >
          <VideoGrid videos={resourceVideos.slice(0, 3)} />
        </ResourceWrapper>
        <ResourceWrapper
          loading={mediaResourcesLoading}
          wrapperCount={resourceDocuments.length}
          wrapperLimit={3}
          wrapperDescription="Download our ICER Analytics training documents:"
          wrapperHref="/documents"
          WrapperIcon={DescriptionRoundedIcon}
          wrapperTitle="Documents"
        >
          <DocumentGrid documents={resourceDocuments.slice(0, 3)} />
        </ResourceWrapper>
        <ResourceWrapper
          loading={recentUpdatesLoading}
          wrapperCount={recentUpdates.length}
          wrapperLimit={1}
          wrapperHref="/updates"
          WrapperIcon={TipsAndUpdatesRoundedIcon}
          wrapperLabel="Updates"
          wrapperTitle="Recent Updates"
        >
          <RecentUpdates limit={1} />
        </ResourceWrapper>
        <ResourceWrapper
          loading={comingSoonItemsLoading}
          wrapperCount={comingSoonItems.length}
          wrapperLimit={3}
          wrapperHref="/coming-soon"
          WrapperIcon={TipsAndUpdatesRoundedIcon}
          wrapperLabel="Updates"
          wrapperTitle="Coming Soon"
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: "30px" }}>
            {comingSoonItems.map((item, i) => (
              <ComingSoonCard
                key={`coming-soon-item-${i}`}
                drugs={item.drugs}
                title={item.title}
                resource={item.resource}
                report={item.report}
              />
            ))}
          </Box>
        </ResourceWrapper>
      </Container>
    </Box>
  );
};

AppLandingContent.propTypes = {
  mediaResourcesLoading: bool.isRequired,
  mediaResources: array,
  recentUpdatesLoading: bool.isRequired,
  recentUpdates: array,
  comingSoonItemsLoading: bool.isRequired,
  comingSoonItems: array.isRequired,
};

const mapStateToProps = ({ mediaResources, recentUpdates, ...state }) => {
  return {
    mediaResourcesLoading: mediaResources.loading,
    mediaResources: mediaResources.data,
    recentUpdatesLoading: recentUpdates.loading,
    recentUpdates: recentUpdates.data,
    comingSoonItemsLoading: comingSoonLoadingSelector(state),
    comingSoonItems: comingSoonSelector(state, {
      limit: COMING_SOON_ITEM_LIMIT,
    }),
  };
};

export default connectToState(mapStateToProps)(AppLandingContent);
